var App = App || {};

App.ComponentCommunity = (function ($) {
    'use strict';

    function init() {
        const widget = $(".widget-community");
        widget.each(function () {
            const carousel = widget.find(".widget-community-items .splide");
            setCarousel(carousel);
        });
    }
    function setCarousel(carousel) {

        const splide = new Splide(carousel[0], {
            mediaQuery: 'min',
            arrows: false,
            pagination: false,
            type: 'loop',
            pauseOnHover:false,
            fixedWidth: '60%',
            useIndex: true,
            drag: false,
            role: 'group',
            autoScroll: {
                pauseOnHover: false,
                speed: 0.5,
            },
            breakpoints: {
                768: {
                    focus: 1,
                    fixedWidth: '20%',
                }
            }
        });

        // Play/Pause Button functionality
        var isPlaying = true;
        $('.widget-community .splide__toggle').on("click", function () {
            if (splide.Components.AutoScroll.isPaused()) {
                splide.Components.AutoScroll.play();
                $(this).find(".fa-circle-play").removeClass("fa-cirle-play").addClass("fa-circle-pause");
            } else {
                splide.Components.AutoScroll.pause();
                $(this).find(".fa-circle-pause").removeClass("fa-circle-pause").addClass("fa-circle-play");
            }
        });

        splide.mount(window.splide.Extensions);
    }


    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ComponentCommunity.init();
});